module.exports = __webpack_public_path__ + "static/media/Categoria7Piscinas.af51bfb0.jpg";